export const resolveLocationHours = (location, companyData = {}) => {
  if (location?.isDefault) {
    return companyData?.settings?.companyHours || {};
  }

  const locationHours = location?.businessHours;
  if (locationHours && typeof locationHours === 'object' && Object.keys(locationHours).length > 0) {
    return locationHours;
  }

  return companyData?.settings?.companyHours || {};
};

export const resolveLocationTimezone = (location, companyData = {}) => (
  String(location?.timezone || companyData?.businessInfo?.timezone || 'America/New_York').trim()
    || 'America/New_York'
);

export const resolveEffectiveCompanyHours = ({
  location,
  companyData,
  locationId,
  locations = [],
} = {}) => {
  if (location) {
    return resolveLocationHours(location, companyData);
  }

  if (locationId && Array.isArray(locations) && locations.length > 0) {
    const matchedLocation = locations.find((item) => item.id === locationId);
    if (matchedLocation) {
      return resolveLocationHours(matchedLocation, companyData);
    }
  }

  return companyData?.settings?.companyHours || {};
};
